import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react'
import RouterTooltip from '../../../../components/RouterTooltip'
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
  DragEndEvent,
} from '@dnd-kit/core'
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
  useSortable,
} from '@dnd-kit/sortable'
import {
  restrictToVerticalAxis,
  restrictToParentElement,
} from '@dnd-kit/modifiers'
import { CSS } from '@dnd-kit/utilities'
import save from '../../../../assets/router/save.svg'
import {
  Container,
  FormContainer,
  InputDiv,
  InputLabel,
  Input,
  StyledSelect,
  StyledOption,
  StyledDate,
  IframeContainer,
  ButtonOfSection,
  ButtonOfSectionText,
  OptionsDiv,
  StyledLink,
  StyledSearch,
  OptionsContainer,
  StyledFreightText,
  StyledFreight,
  StyledCheckList,
  FreightInfo,
  StyledFreightSubText,
  StyledFreightObsText,
  ContentContainer,
  StyledChecklistContainer,
  ContainerHeader,
  BigText,
  DivComponents,
  ButtonContainer,
  SwitchDiv,
  SwitchBox,
  SwitchInput,
  SwitchSlider,
  SelectData,
} from './style'
import SectionContext from '../../../../contexts/SectionContext'
import { Button } from 'react-bootstrap'
import { OptionSubText } from '../../../../components/AddStockModal/style'
import { mock } from './utils'
import { Freight as FreightType, RouterContext } from '../../../../contexts/RouterContext'
import axios from '../../../../config/axios'
import { id, ro } from 'date-fns/locale'
import { set } from 'date-fns'
import {
  GoogleMap,
  Marker,
  InfoWindow,
  useLoadScript,
  DirectionsRenderer,
  DirectionsService,
} from '@react-google-maps/api'
import MyMap from './map'
import { RouterInfoContext } from '../../../../contexts/RouterInfoContext'
import { useNavigate, useOutletContext } from 'react-router-dom'
import { RouterOutletType } from '../index2'
import { ButtonCreate } from '../../../../components/styles/subheader-style'
import { FeedbackContext } from '../../../../contexts/FeedbackContext'
import {
  CenterItensContainer,
  ConformityStatus,
} from '../../../../components/routerModal/freightContent/freightForm/style'
import { Check, Info } from 'lucide-react'
import view from '../../../../assets/global-assets/view.svg'

interface Waypoints {
  location: string
  stopover: boolean
}

interface FreightItem {
  id: number
  Company: {
    companyName: string
  }
  Address: {
    street: string
    number: string
    Neighborhood: {
      City: {
        name: string
        State: {
          uf: string
        }
      }
    }
  }
  routeId?: number | null
  observation?: string
}

// Draggable Freight Item Component
const DraggableFreightItem: React.FC<{
  freight: FreightType
  onSelect: (id: number, freight: FreightType) => void
}> = ({ freight, onSelect }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: freight.id.toString(),
  })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  }

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <StyledFreight
        onClick={() => onSelect(freight.id, freight)}
        style={{
          cursor: 'grab',
          border: isDragging ? '2px dashed #3b82f6' : undefined,
          backgroundColor: isDragging ? '#f3f4f6' : undefined,
        }}
      >
        <StyledChecklistContainer>
          <StyledCheckList className='selected' />
        </StyledChecklistContainer>
        <FreightInfo>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <StyledFreightText title={freight.Company.companyName}>
              {freight.Company.companyName.split(' ').slice(0, 2).join(' ')}
            </StyledFreightText>
            {/* <div style={{
                            fontSize: '12px',
                            color: '#6b7280',
                            backgroundColor: '#e5e7eb',
                            padding: '2px 6px',
                            borderRadius: '4px'
                        }}>
                            Arraste para reordenar
                        </div> */}
          </div>
          <div>
            <StyledFreightSubText>
              {`${freight.Address.street}, ${freight.Address.number} - ${freight.Address.Neighborhood.City.name}/${freight.Address.Neighborhood.City.State.uf}`}
            </StyledFreightSubText>
            {freight.observation && (
              <StyledFreightObsText title={freight.observation}>
                Obs: {freight.observation}
              </StyledFreightObsText>
            )}
          </div>
        </FreightInfo>
        <RouterTooltip key={`draggable-${freight.id}`} freight={freight}>
          {' '}
          <img src={view} alt='view-icon' />
        </RouterTooltip>
      </StyledFreight>
    </div>
  )
}

const NewRouter = () => {
  // Date formatting functions
  const formatToDateInput = (dateString: string): string => {
    if (!dateString || dateString.length < 10) return ''
    const [day, month, year] = dateString.split('/')
    return `${year}-${month}-${day}`
  }

  const formatFromDateInput = (dateString: string): string => {
    if (!dateString || dateString.length < 10) return ''

    const dateRegex = /^\d{4}-\d{2}-\d{2}$/
    if (!dateRegex.test(dateString)) return ''

    const [year, month, day] = dateString.split('-')

    if (year.length !== 4) return ''

    return `${day}/${month}/${year}`
  }

  const dataFormatter = (isoDateString: string): string => {
    if (!isoDateString) {
      return '' // Retorna vazio se a string for nula ou vazia
    }

    const dateUtc = new Date(isoDateString)

    // Verifica se a data é válida antes de tentar formatar
    if (isNaN(dateUtc.getTime())) {
      console.error('Data ISO inválida recebida:', isoDateString)
      return '' // Trata o caso de uma string de data inválida
    }

    // Extrai as partes da data diretamente do UTC
    const year = dateUtc.getUTCFullYear()
    const month = dateUtc.getUTCMonth() + 1 // getUTCMonth é 0-indexado, então adiciona 1
    const day = dateUtc.getUTCDate()

    // Garante que mês e dia tenham dois dígitos (ex: 01 em vez de 1)
    const formattedMonth = month < 10 ? `0${month}` : month
    const formattedDay = day < 10 ? `0${day}` : day

    return `${formattedDay}/${formattedMonth}/${year}`
  }

  const dataFormatterISO = (dateString: string): string => {
    // Verifica se a string de data está no formato esperado (dd/mm/yyyy)
    const parts = dateString.split('/')
    if (parts.length !== 3) {
      console.error(
        "Formato de data inválido. Esperado 'dd/mm/yyyy'. Recebido:",
        dateString,
      )
      // Ou você pode lançar um erro: throw new Error("Formato de data inválido.");
      return '' // Retorna uma string vazia ou trata o erro como preferir
    }

    const [day, month, year] = parts

    // Constrói um objeto Date em UTC para evitar problemas de fuso horário local
    // Lembre-se que o mês no construtor de Date é 0-indexado (Janeiro = 0, Fevereiro = 1, etc.)
    const dateObject = new Date(
      Date.UTC(parseInt(year), parseInt(month) - 1, parseInt(day)),
    )

    // Opcional: Validação para datas inválidas (ex: "30/02/2025")
    // Se a data fornecida for inválida, Date.UTC() ainda pode criar um objeto Date,
    // mas com o dia "corrigido" (ex: 30/02 vira 02/03).
    // Esta verificação garante que a data original era logicamente válida.
    if (
      dateObject.getUTCFullYear() !== parseInt(year) ||
      dateObject.getUTCMonth() !== parseInt(month) - 1 ||
      dateObject.getUTCDate() !== parseInt(day)
    ) {
      console.error("A data original ('" + dateString + "') é inválida.")
      return '' // Retorna string vazia ou trata o erro
    }

    // Converte o objeto Date para a string ISO 8601 (ex: "2025-02-28T00:00:00.000Z")
    return dateObject.toISOString()
  }

  const { setFeedback } = useContext(FeedbackContext)
  const { setTabIndex } = useOutletContext<RouterOutletType>()
  const navigate = useNavigate()
  const { routerSection, setRouterSection } = useContext(SectionContext)
  const [test, setTest] = useState(false)
  const { router, setRouter } = useContext(RouterContext)
  const [freightSelected, setFreightSelected] = useState<number[]>([])
  const [orderedFreights, setOrderedFreights] = useState<FreightType[]>([])
  const [addressFreight, setAddressFreight] = useState<string[]>([])
  const [freights, setFreights] = useState<FreightType[]>([])
  const [url, setUrl] = useState(
    'https://www.google.com.br/maps?q=06278-010,%20Brasil&output=embed',
  )
  const [date, setDate] = useState(dataFormatter(router?.date || ''))
  const [selectedVehicle, setSelectedVehicle] = useState<number>(
    router?.Vehicle?.id || 0,
  )
  const [vehicles, setVehicles] = useState<any[]>([])
  const [companyDestination, setCompanyDestination] = useState<boolean>(
    router?.companyDestination || true,
  )
  const [duplicateBlocker, setDuplicateBlocker] = useState<boolean>(false)
  const [responsible, setresponsible] = useState<string>(
    router?.responsible || '',
  )

  const initialWaypoints = useMemo(() => {
    return []
  }, [])
  const [waypoints, setWayPoints] = useState<Waypoints[]>(initialWaypoints)
  const { routerInfo, setRouterInfo } = useContext(RouterInfoContext)

  // Drag and drop sensors
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8,
      },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  )

  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value

    if (value.length > 10) {
      e.target.value = value.slice(0, 10)
      return
    }

    if (value.length === 10) {
      const year = value.split('-')[0]
      if (year.length > 4) {
        e.target.value = value.slice(0, 6) + value.slice(7)
        return
      }
    }

    setDate(formatFromDateInput(value))
  }

  // Handle drag end for reordering
  const handleDragEnd = (event: DragEndEvent) => {
    const { active, over } = event

    if (!over || active.id === over.id) {
      return
    }

    const activeIndex = orderedFreights.findIndex(
      (freight) => freight.id.toString() === active.id,
    )
    const overIndex = orderedFreights.findIndex(
      (freight) => freight.id.toString() === over.id,
    )

    if (activeIndex !== -1 && overIndex !== -1) {
      const newOrderedFreights = arrayMove(
        orderedFreights,
        activeIndex,
        overIndex,
      )
      setOrderedFreights(newOrderedFreights)

      // Update waypoints to match new order
      const newWaypoints = newOrderedFreights.map((freight) => ({
        location: `${freight.Address.street}, ${freight.Address.number} - ${freight.Address.Neighborhood.City.name}/${freight.Address.Neighborhood.City.State.uf}`,
        stopover: true,
      }))
      setWayPoints(newWaypoints)
    }
  }

  const postRouter = async () => {
    setDuplicateBlocker(true)
    try {
      const body = {
        date: dataFormatterISO(date),
        status: 'A programar',
        freightIds: orderedFreights.map((freight) => freight.id),
        track: routerInfo?.track,
        companyDestination: companyDestination,
        url:
          routerInfo?.url ||
          'https://www.google.com.br/maps?q=06278-010,%20Brasil&output=embed',
        origin: router?.origin || 'vendas',
        vehicleId: Number(selectedVehicle),
        responsible: responsible,
      }

      const response = await axios.post(
        `${process.env.REACT_APP_GATEWAY_BASE_URL}/router/route`,
        body,
      )
      setFeedback({
        isOpen: true,
        message: 'Rota criada com sucesso!',
        statusOk: true,
      })
      setDuplicateBlocker(false)
      setRouterSection('routers')
      navigate('/panel/router/routers')
    } catch {
      setFeedback({
        isOpen: true,
        message: 'Erro ao criar rota!',
        statusOk: false,
      })
      setDuplicateBlocker(false)
    }
  }

  const putRouter = async () => {
    setDuplicateBlocker(true)
    try {
      const body = {
        id: router?.id,
        date: dataFormatterISO(date),
        status: 'A programar',
        freightIds: orderedFreights.map((freight) => freight.id),
        companyDestination: companyDestination,
        track: routerInfo?.track,
        url: routerInfo?.url,
        origin: router?.origin || 'vendas',
        vehicleId: Number(selectedVehicle),
        responsible: responsible,
      }
      const response = await axios.put(
        `${process.env.REACT_APP_GATEWAY_BASE_URL}/router/route`,
        body,
      )
      setRouter(null)
      setRouterSection('routers')
      navigate('/panel/router/routers')
      setFeedback({
        isOpen: true,
        message: 'Rota atualizada com sucesso!',
        statusOk: true,
      })
      setDuplicateBlocker(false)
    } catch {
      setFeedback({
        isOpen: true,
        message: 'Erro ao atualizar rota!',
        statusOk: false,
      })
      setDuplicateBlocker(false)
    }
  }

  const updateFreigth = (id: number, freight: FreightType) => {
    if (freightSelected.includes(id)) {
      setFreightSelected(
        freightSelected.filter((freightId) => freightId !== id),
      )
      setOrderedFreights(orderedFreights.filter((item) => item.id !== id))
      setFreights([...freights, freight])
      setWayPoints(
        waypoints.filter(
          (wayPoint) =>
            wayPoint.location !==
            `${freight.Address.street}, ${freight.Address.number} - ${freight.Address.Neighborhood.City.name}/${freight.Address.Neighborhood.City.State.uf}`,
        ),
      )
    } else {
      setFreightSelected([...freightSelected, id])
      setOrderedFreights([...orderedFreights, freight])
      setFreights(freights.filter((item) => item.id !== id))
      const newAddress = `${freight.Address.street}, ${freight.Address.number} - ${freight.Address.Neighborhood.City.name}/${freight.Address.Neighborhood.City.State.uf}`
      setWayPoints([...waypoints, { location: newAddress, stopover: true }])
    }
  }

  const handleVehicle = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newVehicle = Number(e.target.value)
    if (newVehicle === selectedVehicle) {
      setSelectedVehicle(0)
    } else {
      setSelectedVehicle(newVehicle)
    }
  }

  useEffect(() => {
    const getFreights = async () => {
      const url = `${process.env.REACT_APP_GATEWAY_BASE_URL}/router/freight/route/${0}`
      const response = await axios.get(url)
      setFreights(response.data)
    }

    const getVehicles = async () => {
      const response = await axios.get(
        `${process.env.REACT_APP_GATEWAY_BASE_URL}/equipment/vehicles`,
      )
      setVehicles(response.data)
    }

    getVehicles()
    getFreights()
  }, [])

  useEffect(() => {
    if (router) {
      setFreightSelected(
        router.Freight.map((freight: FreightItem) => freight.id),
      )
      setOrderedFreights(router.Freight)
      setSelectedVehicle(router.Vehicle.id)
      setDate(dataFormatter(router.date))
      if (router.companyDestination !== undefined) {
        setCompanyDestination(router.companyDestination)
      }
      if (router.responsible !== undefined) {
        setresponsible(router.responsible)
      }
      setWayPoints(
        router.Freight.map((freight: FreightItem) => {
          return {
            location: `${freight.Address.street}, ${freight.Address.number} - ${freight.Address.Neighborhood.City.name}/${freight.Address.Neighborhood.City.State.uf}`,
            stopover: true,
          }
        }),
      )
    }
  }, [router?.id])

  const Maps = useMemo(() => {
    const MapsComponent: React.FC = () => {
      const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY
      const defaultCenter = {
        lat: -23.473030452297433,
        lng: -46.78039101579958,
      }
      const defaultZoom = 11
      const initialMarkers = [
        { lat: -23.56, lng: -46.65 },
        { lat: -23.54, lng: -46.62 },
      ]

      if (!googleMapsApiKey) {
        throw new Error('Google Maps API key is not set')
      }

      return (
        <div style={{ width: '100%', height: '100%' }}>
          <MyMap
            apiKey={googleMapsApiKey}
            center={defaultCenter}
            zoom={defaultZoom}
            markers={initialMarkers}
            wayPoints={waypoints}
            companyDestination={companyDestination}
          />
        </div>
      )
    }

    return <MapsComponent />
  }, [waypoints, companyDestination])

  const getRouterTooltipText = (freight: FreightType): string => {
    return `Empresa: ${freight.Company.companyName}\nEndereço: ${
      freight.Address.street
    }, ${freight.Address.number} - ${freight.Address.Neighborhood.City.name}/${
      freight.Address.Neighborhood.City.State.uf
    }\nObs: ${freight.observation || 'Não há'}`
  }

  return (
    <>
      {/* <ContainerHeader>
                <BigText>Novo roteiro:</BigText>
                <OptionsDiv>
                    <ButtonOfSection onClick={() => router ? putRouter() : postRouter()}>
                        <ButtonOfSectionText>{router ? 'Atualizar roteiro' : 'Criar roteiro'}</ButtonOfSectionText>
                    </ButtonOfSection>
                </OptionsDiv>
            </ContainerHeader> */}

      <DivComponents style={{ border: '' }}>
        <OptionsDiv className='reverse'>
          <StyledLink
            onClick={() => {
              setRouterSection('routers')
              // setTabIndex(1)
              navigate('/panel/router/routers')
              setRouter(null)
            }}
            className='linkMode'
          >
            Roteiros e fretes
          </StyledLink>
          <StyledLink style={{ marginLeft: '0.3rem' }}>
            {' '}
            {router?.id ? '> Editar roteiro' : '> Novo roteiro'}
          </StyledLink>
        </OptionsDiv>
        <Container>
          <FormContainer>
            <InputDiv>
              <CenterItensContainer>
                <InputLabel>Veículo</InputLabel>
                <ConformityStatus isvalue={!selectedVehicle}>
                  {selectedVehicle ? (
                    <>
                      <Check size={20} />{' '}
                    </>
                  ) : (
                    <>
                      <Info size={18} />{' '}
                    </>
                  )}
                </ConformityStatus>
              </CenterItensContainer>
              <SelectData
                value={selectedVehicle || router?.Vehicle?.id || 0}
                onChange={handleVehicle}
              >
                <StyledOption value={router?.Vehicle?.id || ''}>
                  {router?.Vehicle?.plate || 'Selecione..'}
                </StyledOption>
                {vehicles.map((vehicle) => (
                  <StyledOption key={vehicle.id} value={vehicle.id}>
                    {vehicle.plate}
                  </StyledOption>
                ))}
              </SelectData>
            </InputDiv>

            <InputDiv>
              <CenterItensContainer>
                <InputLabel>Data</InputLabel>
                <ConformityStatus isvalue={date.length < 10}>
                  {!(date.length < 10) ? (
                    <>
                      <Check size={20} />{' '}
                    </>
                  ) : (
                    <>
                      <Info size={18} />{' '}
                    </>
                  )}
                </ConformityStatus>
              </CenterItensContainer>
              <StyledDate
                type='date'
                onChange={handleDateChange}
                value={formatToDateInput(date)}
                max='9999-12-31'
              />
            </InputDiv>

            <InputDiv>
              <InputLabel>Responsável da Rota</InputLabel>
              <Input
                type='text'
                placeholder='Nome do Responsável'
                value={responsible}
                onChange={(e) => setresponsible(e.target.value)}
              />
            </InputDiv>

            <InputDiv>
              <SwitchDiv>
                <InputLabel>Voltar à origem</InputLabel>
                <SwitchBox>
                  <SwitchInput
                    type='checkbox'
                    onClick={() => setCompanyDestination(!companyDestination)}
                    checked={companyDestination}
                  />
                  <SwitchSlider className='slider'></SwitchSlider>
                </SwitchBox>
              </SwitchDiv>
            </InputDiv>

            <InputDiv>
              <div style={{ display: 'flex' }}>
                <InputLabel>Frete</InputLabel>
                <p
                  style={{
                    fontSize: '12px',
                    color: '#0091d4',
                    backgroundColor: '#e5e7eb',
                    padding: '2px 8px ',
                    borderRadius: '12px',
                    fontWeight: 'bold',
                    marginLeft: '0.5rem',
                  }}
                >
                  {routerInfo?.track}
                </p>
              </div>
              <StyledSearch placeholder='Selecione...'></StyledSearch>
            </InputDiv>
            <OptionsContainer>
              {/* Selected Freights Section with Drag and Drop */}
              {orderedFreights.length > 0 && (
                <div style={{ marginBottom: '16px' }}>
                  <div
                    style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#374151',
                      marginBottom: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                    }}
                  >
                    Fretes Selecionados ({orderedFreights.length})
                    {/* <span style={{
                                            fontSize: '12px',
                                            color: '#6b7280',
                                            backgroundColor: '#e5e7eb',
                                            padding: '2px 8px',
                                            borderRadius: '12px'
                                        }}>
                                            Arraste para reordenar
                                        </span> */}
                  </div>

                  <DndContext
                    sensors={sensors}
                    collisionDetection={closestCenter}
                    onDragEnd={handleDragEnd}
                    modifiers={[
                      restrictToVerticalAxis,
                      restrictToParentElement,
                    ]}
                  >
                    <SortableContext
                      items={orderedFreights.map((f) => f.id.toString())}
                      strategy={verticalListSortingStrategy}
                    >
                      {orderedFreights.map((freight) => (
                        <DraggableFreightItem
                          key={freight.id}
                          freight={freight}
                          onSelect={updateFreigth}
                        />
                      ))}
                    </SortableContext>
                  </DndContext>
                </div>
              )}

              {/* Available Freights Section */}
              {freights.length > 0 && (
                <div>
                  {orderedFreights.length > 0 && (
                    <div
                      style={{
                        fontSize: '14px',
                        fontWeight: '600',
                        color: '#374151',
                        marginBottom: '8px',
                      }}
                    >
                      Fretes Disponíveis
                    </div>
                  )}

                  {freights.map((freight: FreightType) => {
                    if (!freightSelected.includes(freight.id)) {
                      return (
                        <RouterTooltip
                          key={`draggable-${freight.id}`}
                          freight={freight}
                        >
                          <StyledFreight
                            key={`available-${freight.id}`}
                            onClick={() => updateFreigth(freight.id, freight)}
                          >
                            <StyledChecklistContainer>
                              <StyledCheckList
                                className={
                                  freightSelected.includes(freight.id)
                                    ? 'selected'
                                    : ''
                                }
                              />
                            </StyledChecklistContainer>
                            <FreightInfo>
                              <StyledFreightText
                                title={freight.Company.companyName}
                              >
                                {freight.Company.companyName
                                  .split(/\s|-/)
                                  .slice(0, 2)
                                  .join(' ') + '...'}
                              </StyledFreightText>
                              <div>
                                <StyledFreightSubText>
                                  {`${freight.Address.street}, ${freight.Address.number} - ${freight.Address.Neighborhood.City.name}/${freight.Address.Neighborhood.City.State.uf}`}
                                </StyledFreightSubText>
                                {freight.observation && (
                                  <StyledFreightObsText
                                    title={freight.observation}
                                  >
                                    Obs: {freight.observation}
                                  </StyledFreightObsText>
                                )}
                              </div>
                            </FreightInfo>
                          </StyledFreight>
                        </RouterTooltip>
                      )
                    }
                    return null
                  })}
                </div>
              )}
            </OptionsContainer>
          </FormContainer>
          <div style={{ width: '100%', paddingBottom: '4rem' }}>
            <IframeContainer>{Maps}</IframeContainer>
            <ButtonContainer
              style={{ marginTop: '0.5rem', marginBottom: '0.5rem' }}
            >
              {duplicateBlocker ? (
                <ButtonCreate className='disable'>Aguarde</ButtonCreate>
              ) : (
                <ButtonCreate
                  onClick={() => (router ? putRouter() : postRouter())}
                >
                  <img
                    style={{ width: '1.5rem', height: '1.5rem' }}
                    src={save}
                  />
                  Salvar Rota
                </ButtonCreate>
              )}
            </ButtonContainer>
          </div>
        </Container>
      </DivComponents>
    </>
  )
}

export default NewRouter
